import { PropsWithChildren } from 'react';

import { FieldWrapper } from '../field-wrapper';

export function AreaAdornment({ children }: PropsWithChildren<unknown>) {
  return (
    <FieldWrapper>
      {children}
      <FieldWrapper.EndAdornment>
        <span className="text-secondary text-sm">m²</span>
      </FieldWrapper.EndAdornment>
    </FieldWrapper>
  );
}
